import { render, staticRenderFns } from "./Graphic.vue?vue&type=template&id=1f8d3070&"
import script from "./Graphic.vue?vue&type=script&lang=js&"
export * from "./Graphic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports